import { defineMessages } from "react-intl";

export default defineMessages({
  totalByHour: {
    id: "orderDescription.totalByHour",
    defaultMessage: "Total / hour",
  },
  totalByDay: {
    id: "orderDescription.totalByDay",
    defaultMessage: "Total / day",
  },
  totalByWeek: {
    id: "orderDescription.totalByWeek",
    defaultMessage: "Total / week",
  },
  total: {
    id: "orderDescription.total",
    defaultMessage: "Total",
  },
  advancePayment: {
    id: "orderDescription.advancePayment",
    defaultMessage: "Advance payment",
  },
});
